import baseClasses from '@components/Themes/layout.module.scss'
import React, { FunctionComponent } from 'react'

import '@components/MapBox/mapbox.css'
import { Close } from '@mui/icons-material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import HomeIcon from '@mui/icons-material/Home'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import stylesmodulescss from 'dist/css/parqueDiamante.module.scss'
import { Helmet } from 'react-helmet'
import type { LayerProps } from 'react-map-gl'
import Map, { Layer, ScaleControl, Source } from 'react-map-gl'
import { NavLink } from 'react-router-dom'

export const clusterLayer: LayerProps = {
  id: 'clusters',
  type: 'circle',
  source: 'earthquakes',
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': ['step', ['get', 'point_count'], 'rgba(206, 13, 45, 0.75)', 10, 'rgba(206, 13, 45, 0.5)', 750, '#f28cb1'],
    'circle-radius': ['step', ['get', 'point_count'], 16, 10, 32, 750, 64],
  },
}

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'earthquakes',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 10,
  },
}

export const unclusteredPointLayer: LayerProps = {
  id: 'unclustered-point',
  type: 'circle',
  source: 'earthquakes',
  filter: ['!', ['has', 'point_count']],
  paint: {
    'circle-color': 'rgb(206, 13, 45)',
    'circle-opacity': 0.84,
    'circle-radius': 8,
    'circle-stroke-width': 2,
    'circle-stroke-color': '#fff',
  },
}

import AuthService from '../services/auth.service'

import { translation } from 'dist/translations'

import axios from 'axios'

const MapaDiamante: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const theme = { ...baseClasses, ...stylesmodulescss }
  const [language, setlanguage] = React.useState<any>('es')
  const [downloadPopUp, setdownloadPopUp] = React.useState<any>(false)
  const imagesRef = React.useRef<Record<string, string>>({})
  const [currentUser, setcurrentUser] = React.useState<any>(null)
  const [mapZoom, setmapZoom] = React.useState<any>(null)
  const [mapCenter, setmapCenter] = React.useState<any>(null)
  const [coordinatesMap, setcoordinatesMap] = React.useState<any>(null)
  const [maxBoundsMap, setmaxBoundsMap] = React.useState<any>(null)
  const [mapURL, setmapURL] = React.useState<any>(null)
  const [selectedPlace, setselectedPlace] = React.useState<any>(null)
  const [locat, setlocat] = React.useState<any>([0, 0])
  const [routePlaces, setroutePlaces] = React.useState<any>([])
  const [zoom, setzoom] = React.useState<any>(14)
  const [images, setimages] = React.useState<any>([])
  const mapRef = React.useRef(null)

  // Theme selection

  const showBackButton = false

  const isDescarga = params.id === 'Descarga'

  const calculateMapCenter = (coordinates) => {
    if (!coordinates || coordinates.length === 0) return null

    const lons = coordinates.map((c) => c[0])
    const lats = coordinates.map((c) => c[1])

    const centerLon = (Math.min(...lons) + Math.max(...lons)) / 2
    const centerLat = (Math.min(...lats) + Math.max(...lats)) / 2

    const lonDiff = Math.max(...lons) - Math.min(...lons)
    const latDiff = Math.max(...lats) - Math.min(...lats)
    const maxDiff = Math.max(lonDiff, latDiff)

    let zoom = 16
    if (maxDiff > 0.01) zoom = 14
    if (maxDiff > 0.05) zoom = 12
    if (maxDiff > 0.1) zoom = 11
    if (maxDiff > 0.5) zoom = 9

    return { center: [centerLon, centerLat], zoom }
  }

  const bringInfo = async () => {
    try {
      const lat = locat?.latitude
      const long = locat?.longitude

      const res = await fetch('https://api.ipify.org?format=json')
      const { ip } = await res.json()

      // 🌍 Primer request con token
      const route = await axios.get(`https://api.realtravelapp.com/public/route/${params?.id}`, {
        params: {
          lat,
          lon: long,
        },
        headers: {
          'X-User-Lat': String(lat),
          'X-User-Lon': String(long),
          'X-User-Agent': 'web',
          'X-Forwarded-For': ip,
        },
      })
console.log('route.data', params?.id)
      if (route?.data?.mapUrl) {
        const maxBoundsString = route?.data?.maxBounds
        const jsonString = `{${maxBoundsString.replace(/(\w+):/g, '"$1":')}}`
        const parsedBounds = JSON.parse(jsonString)

        const fixedMaxBounds = [
          parsedBounds.sw, // [lng, lat]
          parsedBounds.ne, // [lng, lat]
        ]

        setmaxBoundsMap(fixedMaxBounds)

        const coordenadasIniciales = JSON.parse(route?.data?.coordinates)
        setcoordinatesMap(coordenadasIniciales)

        const mapConfig = calculateMapCenter(coordenadasIniciales)
        if (mapConfig) {
          setmapCenter(mapConfig.center)
          setmapZoom(mapConfig.zoom)
        }

        setmapURL(route?.data?.mapUrl)
      }

      setroutePlaces(route.data.dots)
    } catch (e) {
      console.log(e)
    }
  }

  routePlaces?.forEach((place: any) => {
    if (place?.placeType?.icon) {
      images[place?.id] = { uri: place?.placeType?.icon } // cada id es la key
    }
  })

  const geoJsonPlaces = {
    type: 'FeatureCollection',
    features: routePlaces
      ?.filter((p) => p.latitude != null && p.longitude != null)
      .map((place: any) => ({
        type: 'Feature',
        id: place.id,
        properties: {
          id: place.id,
          name: place?.name,
          distance: place?.distance ? (place.distance / 1000).toFixed(2) : null,
          coverUrl: place?.coverUrl,
          type: place?.placeType?.name,
          country: place?.address?.countryCode,
          description: place?.description,
          latitude: Number(place?.latitude),
          longitude: Number(place?.longitude),
          icon: place?.placeType?.icon ? place.id : 'dot-red',
        },
        geometry: {
          type: 'Point',
          coordinates: [Number(place.longitude), Number(place.latitude)],
        },
      })),
  }

  React.useEffect(() => {
    const imgs: Record<string, string> = {}

    routePlaces.forEach((place) => {
      if (place?.placeType?.icon) {
        imgs[place.id] = place.placeType.icon // URL directa
      }
    })

    imagesRef.current = imgs
  }, [routePlaces])

  React.useEffect(() => {
    let isMounted = true

    const run = async () => {
      if (!isMounted) return
        await bringInfo()

    }

    run()

    return () => {
      isMounted = false
    }
  }, [params.id])



  return (
    <React.Fragment>
      <div className={classes.mainPanel}>
        <Helmet>
          <title>App Real Travel </title>
          <meta name="title" property="og:title" content="Real Travel " />
        </Helmet>

        <Dialog
          open={!!downloadPopUp}
          onClose={(e) => {
            setdownloadPopUp(false)
          }}
          maxWidth={'xs'}
          className={theme.downloadPopUp}
        >
          <div data-title="containerPopUp" className={theme.containerPopUp}>
            <picture className={theme.qrPopUp}>
              <img src="/img/QRSinFondo.png" alt="/img/QRSinFondo.png" width="600" />
            </picture>
            <div data-title="actionsPopUp" className={theme.actionsPopUp}>
              <Button
                color="primary"
                onClickCapture={(e) => {
                  setdownloadPopUp(false)
                }}
                className={theme.actionPopUpButton}
              >
                <span className={theme.actionPopUpText}>Cerrar</span>
              </Button>
            </div>
          </div>
        </Dialog>

        <Dialog
          open={!!selectedPlace}
          onClose={(e) => {
            setselectedPlace(null)
          }}
          maxWidth={'xs'}
          className={theme.popUpDot}
        >
          <div data-title="div" onClick={(e) => setselectedPlace(null)}>
            <Close
              color="inherit"
              className={theme.closeButtonDetails}
              sx={{
                fontSize: 20,
              }}
            />
          </div>

          <div data-title="Image" className={theme.containerImgPopUp}>
            <div className={theme.imgPopUp}>
              <img src={selectedPlace?.coverUrl} alt={selectedPlace?.coverUrl} height="234" />
            </div>
          </div>

          <div data-title="Info" className={theme.infoPopUp}>
            <div data-title="typeCard" className={theme.typeCardPopUp}>
              <span className={theme.typeCardText}>{selectedPlace?.type}</span>
            </div>

            <div data-title="titleDistancePopUp" className={theme.titleDistancePopUp}>
              <span className={theme.titleCard}>{selectedPlace?.name}</span>
            </div>

            <span className={theme.descriptionPopUp}>{selectedPlace?.description}</span>

            <NavLink className={theme.actionsPopUp} to={`/infoDiamante/${selectedPlace?.id}`}>
              <Button color="primary" className={theme.actionPopUpButton}>
                <span className={theme.actionPopUpText}>Ir al detalle</span>
              </Button>
            </NavLink>
          </div>
        </Dialog>

        <div data-title="Bottom Menu" className={theme.bottomMenu}>
          <div data-title="Ruta Parque completo" className={theme.bottomLink}>
            <NavLink className={theme.bottomLink} to="/DiamanteAdventure/7a8f7842-bee4-4b55-988c-bb166d423dbb">
              <span className={theme.bottomLinkText}>Aventura en Diamante</span>
            </NavLink>
          </div>

          <div data-title="Ruta Santuario" className={theme.bottomLink}>
            <NavLink className={theme.bottomLink} to="/DiamanteAdventure/8135a118-85dc-4fbc-b3f7-6056adbe26a5">
              <span className={theme.bottomLinkText}>Santuario de Animales</span>
            </NavLink>
          </div>

          <div data-title="Descarga RT" className={theme.bottomLink}>
            <NavLink className={theme.bottomLink} to="/DiamanteAdventure/Descarga">
              <span className={theme.bottomLinkText}>Descarga Real Travel</span>
            </NavLink>
          </div>
        </div>

        {isDescarga && (
          <React.Fragment>
            <div data-title="div" className={theme.descargaRT}>
              <picture className={theme.imgDiamante}>
                <img src="/img/RT_roj_frase.png" alt="/img/RT_roj_frase.png" width="300" height="79" />
              </picture>
              <div data-title="container" className={theme.container}>
                <div data-title="div" className={theme.redirect}>
                  <a
                    target="_blank"
                    className={theme.linkT}
                    href="https://linktr.ee/realtravelap?fbclid=PAZXh0bgNhZW0CMTEAAaaoP7ADvVgADbOm7Nod0HrVqIYUHpKEcSl940o5UxU6voc1DavpNM5W--k_aem_DsjjGZqJPndrQ-OCgDpyhQ"
                  >
                    <span className={theme.textLinkT}>¡Descarga la App!</span>
                  </a>
                </div>
              </div>

              <div data-title="title Container" className={theme.titleContainer}>
                <Typography variant="h4">¡Disfruta Diamante y descubre todo lo que tiene para ofrecer Costa Rica!</Typography>
              </div>
            </div>
          </React.Fragment>
        )}

        {!isDescarga && (
          <div className={theme.mapBox}>
            <Map
              interactiveLayerIds={['G6mRxlBh', 'MJHSIogD']}
              initialViewState={{
                latitude: locat.latitude,
                longitude: locat.longitude,
                zoom: zoom,
                bearing: 0,
                pitch: 0,
              }}
              ref={mapRef}
              mapStyle="mapbox://styles/mapbox/light-v9"
              mapboxAccessToken="pk.eyJ1IjoicmVhbHRyYXZlbCIsImEiOiJjbWZ3eGoyYW4wNDN5Mmpweng1M25yZWNkIn0.mGtlX_yuRk6L7PjNpnnfrQ"
              onLoad={(e) => {
                const map = mapRef.current?.getMap()
                if (!map) return

                // Precargar TODAS las imágenes apenas carga el mapa
                const loadAllImages = async () => {
                  const imagePromises = Object.entries(imagesRef.current).map(([id, url]) => {
                    return new Promise((resolve) => {
                      // Si ya está cargada, skip
                      if (map.hasImage(id)) {
                        resolve(true)
                        return
                      }

                      map.loadImage(url, (err, image) => {
                        if (err || !image) {
                          console.error('❌ Error cargando icono:', url)
                          resolve(false)
                          return
                        }

                        map.addImage(id, image)
                        console.log('✅ Imagen cargada:', id)
                        resolve(true)
                      })
                    })
                  })

                  await Promise.all(imagePromises)
                  console.log('🎉 Todas las imágenes precargadas')
                }

                // Ejecutar precarga
                loadAllImages()

                // Mantener el listener por si acaso (para íconos dinámicos futuros)
                map.on('styleimagemissing', (e) => {
                  const id = e.id
                  const url = imagesRef.current[id]

                  if (!url) return

                  map.loadImage(url, (err, image) => {
                    if (err || !image) {
                      console.error('❌ Error cargando icono:', url)
                      return
                    }

                    if (!map.hasImage(id)) {
                      map.addImage(id, image)
                    }
                  })
                })
              }}
              maxBounds={maxBoundsMap}
              onClick={(e) => {
                const feature = e.features?.[0]
                if (!feature) return

                const props = feature.properties

                if (!props?.id) return

                setselectedPlace({
                  id: props.id,
                  name: props.name,
                  type: props.type,
                  coverUrl: props.coverUrl,
                  country: props.country,
                  description: props.description,
                  distance: props.distance,
                  latitude: props.latitude,
                  longitude: props.longitude,
                })
              }}
            >
              <ScaleControl />

              {mapURL !== null && (
                <React.Fragment>
                  <Source id="custom-image" type="image" url={mapURL} coordinates={coordinatesMap}>
                    <Layer
                      id="custom-image-layer"
                      type="raster"
                      paint={{
                        'raster-opacity': 1,
                      }}
                    />
                  </Source>

                  <Source id="G6mRxlBh" type="geojson" data={geoJsonPlaces} cluster={true} clusterMaxZoom={14} clusterRadius={50}>
                    <Layer
                      id="MJHSIogD"
                      type="symbol"
                      filter={['!', ['has', 'point_count']]}
                      layout={{
                        'icon-image': ['get', 'icon'],
                        'icon-size': ['interpolate', ['exponential', 2], ['zoom'], 4.5, 0.15, 21, 1],
                        'icon-allow-overlap': true,
                      }}
                      paint={{}}
                    />
                  </Source>
                </React.Fragment>
              )}
            </Map>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}

export default MapaDiamante